import React, { useContext } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import * as Sentry from '@sentry/react'

import ContentLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/ContentLayout'
import RootLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/RootLayout'
import { ProductTypeContext } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/productType/productTypeContext'

import MicrositeAndElsewhereTopBanner from '../../../features/microsite/components/Banners/MicrositeAndElsewhereTopBanner'
import ComingSoonMicrositeHomeContainer from '../../../features/microsite/components/comingSoonContainer/ComingSoonMicrositeHomeContainer'
import LyraSelectComingSoonMicrositeHomeContainer from '../../../features/microsite/components/comingSoonContainer/LyraSelectComingSoonMicrositeHomeContainer'
import MicrositeIntlProvider from '../../../features/microsite/MicrositeIntlProvider'
import Header from '../header/Header'
import ToastContainer from '../toastContainer/ToastContainer'

const ComingSoon = () => {
  const { isLyraSelect } = useContext(ProductTypeContext)
  const ComingSoonHomepage = (
    <MicrositeIntlProvider>
      <MicrositeAndElsewhereTopBanner />
      <Header />
      <ToastContainer />
      <ContentLayout>
        {isLyraSelect ? <LyraSelectComingSoonMicrositeHomeContainer /> : <ComingSoonMicrositeHomeContainer />}
      </ContentLayout>
    </MicrositeIntlProvider>
  )

  const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)
  const router = sentryCreateBrowserRouter([
    {
      path: '*',
      index: true,
      element: ComingSoonHomepage,
    },
  ])

  return (
    <RootLayout>
      <RouterProvider router={router} />
    </RootLayout>
  )
}

export default ComingSoon
